import { render, staticRenderFns } from "./SetAsMainButton.vue?vue&type=template&id=6b924dfc&"
import script from "./SetAsMainButton.vue?vue&type=script&lang=js&"
export * from "./SetAsMainButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports